// Lib
import { useRef } from 'react';

export default function useUpdatedRef(val) {
    const ref = useRef(val);
    ref.current = val;
    return ref;
}
